/**
 * Centralized Attendance Color & Style Utilities for Web Portal
 */

export const ATTENDANCE_COLORS = {
  present: '#10b981',      // Emerald Green
  late: '#f59e0b',         // Amber / Orange
  absent: '#ef4444',       // Coral Red
  leave: '#1d4ed8',        // Deep Cobalt Blue
  makeup: '#7c3aed',       // Purple
  holiday: '#64748b',      // Slate Gray
  rescheduled: '#0284c7',  // Bright Sky Blue
  scheduled: '#7b1d3a',    // Wine
  unmarked: '#ef4444',     // Red
  upcoming: 'rgba(123, 29, 58, 0.35)',
};

export const getAttendanceColor = (status) => {
  if (!status) return '#94a3b8';
  const s = String(status).toLowerCase().replace(/[-_\s]/g, '');
  return ATTENDANCE_COLORS[s] || ATTENDANCE_COLORS.absent;
};

export const getAttendanceBadgeClass = (status) => {
  const map = {
    Present: 'badge-green',
    Late: 'badge-gold',
    Absent: 'badge-red',
    Leave: 'badge-blue',
    'Make-up': 'badge-purple',
    Makeup: 'badge-purple',
    Holiday: 'badge-gray',
    Rescheduled: 'badge-sky',
  };
  return map[status] || 'badge-sky';
};
